import React from 'react';

const CustomConfirm = ({ show, message, onConfirm, onCancel }) => {
  if (!show) return null;

  return (
    <div 
      className="fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm animate-fade-in"
      onClick={onCancel}
    >
      <div 
        className="bg-gray-900 rounded-2xl shadow-2xl border border-gray-700 max-w-md w-full transform animate-scale-in"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="bg-gradient-to-r from-yellow-500 to-orange-600 p-4 rounded-t-2xl flex items-center gap-3">
          <span className="text-4xl">⚠️</span>
          <div className="flex-1">
            <h3 className="text-white font-bold text-lg">Onay Gerekli</h3>
          </div>
        </div>

        {/* Content */}
        <div className="p-6">
          <p className="text-gray-300 text-base leading-relaxed whitespace-pre-line">
            {message}
          </p>
        </div>

        {/* Footer with buttons */}
        <div className="p-4 border-t border-gray-700 flex gap-3 justify-end">
          <button
            onClick={onCancel}
            className="px-6 py-2.5 bg-gray-700 hover:bg-gray-600 text-white font-semibold rounded-xl transition-all duration-200"
          >
            İptal
          </button>
          <button
            onClick={onConfirm}
            className="px-6 py-2.5 bg-gradient-to-r from-red-500 to-rose-600 text-white font-semibold rounded-xl hover:opacity-90 transition-all duration-200 transform hover:scale-105"
          >
            Evet, Devam Et
          </button>
        </div>
      </div>
    </div>
  );
};

export default CustomConfirm;
